import { useEffect, useRef } from 'preact/hooks'
import useForceUpdateOnResize from './useForceUpdateOnResize'
import { useAppContext } from '../contexts/AppContext'
import { STEPS } from '../constants'
import { useState } from 'react'

const SWITCH_SLIDE_EVENT = 'WP-slide-switch'

function useHorizontalSliderMethods(isAcReady) {
  const { viewMode, acRootRef } = useAppContext()
  const [stepsNumber, setStepsNumber] = useState([])
  const scrollContainer = useRef(null)
  const updater = useForceUpdateOnResize()
  const step = useRef(0)

  useEffect(() => {
    if (viewMode !== 'funnel') return
    if (!scrollContainer.current) return

    const handler = () => {
      let stepCounter = 0
      const scopes = [...acRootRef.current.shadowRoot.querySelectorAll('[data-separator-scope]')]
      const stepsNumber = scopes.map(() => {
        return { type: stepCounter === 0 ? 'first' : null, step: stepCounter++, stepsNumber: scopes.length }
      })

      stepsNumber.push({
        type: 'last',
        step: stepsNumber.length,
        stepsNumber: stepsNumber.length,
      })

      setStepsNumber(stepsNumber)
    }

    handler()

    addEventListener('AC_scopes_changed', handler)
    return () => {
      removeEventListener('AC_scopes_changed', handler)
    }
  }, [])

  useEffect(async () => {
    if (viewMode !== 'funnel') return
    if (!scrollContainer.current) return

    const stepSize = scrollContainer.current.clientWidth

    scrollContainer.current?.scrollTo({
      left: stepSize * step.current,
    })

    window.AC_next = () => {
      /**
       * `dispatchEvent(new CustomEvent(SWITCH_SLIDE_EVENT))` is needed
       *  to message ac lib to stop video/audio playback in recommendations
       */
      dispatchEvent(new CustomEvent(SWITCH_SLIDE_EVENT))

      scrollContainer.current?.scrollTo({
        left: stepSize * (step.current + STEPS),
        behavior: 'smooth',
      })
      if (stepsNumber[step.current].type !== 'last') step.current++

      return stepsNumber[step.current]
    }

    window.AC_prev = () => {
      dispatchEvent(new CustomEvent(SWITCH_SLIDE_EVENT))
      scrollContainer.current?.scrollTo({
        left: stepSize * (step.current - STEPS),
        behavior: 'smooth',
      })

      if (stepsNumber[step.current].type !== 'first') step.current--

      return stepsNumber[step.current]
    }

    window.AC_getStep = () => {
      return stepsNumber[step.current]
    }
  }, [updater, isAcReady, stepsNumber])

  return scrollContainer
}

export default useHorizontalSliderMethods
